import { useEffect, useState } from "react";
import { _PayrollEntityProperties, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { ListPropsTypePersons } from "./ListPropsTypePersons";
import { GradeExemptEditor } from "./GradeExemptEditor";
import { ListDiscountCodes } from "./ListDiscountCodes";

interface Props {
    payrollEntity: number
}

export const PayrollEntityProperties = ({ payrollEntity }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_PayrollEntityProperties);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (payrollEntity) {
            getLista();
        }
    }, [payrollEntity])

    const getLista = () => {
        const props = { IDPayrollEntity: payrollEntity };
        instance.getPayrollEntityPropertiesCatalogPorPropiedades(props, null).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err); }
        );
    };



    const updateIten = () => {
        instance.updatePayrollEntityProperties(bean).then(
            (resp) => {
                getLista()
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteItem = () => {
        instance.deletePayrollEntityProperties(bean.IDPayrollEntityProperties).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }

    const create = () => {
        setBean({
            RequireServiceTime: false,
            IDEmployee: _single.getAccountID(),
            LastUpdate: _single.getCurrenDate(),
            IDPayrollEntity: payrollEntity,
        });
        setModal({ ...modal, "view": true, "name": "Agregar Caja Nominadora" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar propiedad de la Caja Nominadora" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar propiedad de la Caja Nominadora` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const head = [
        { title: 'ID', property: 'IDPayrollEntityProperties', visible: true },
        { title: 'Dia de Corte', property: 'CutDay', visible: true },
        { title: 'Dia de Notificación', property: 'NotifyDay', visible: true },
        { title: 'Requiere tiempo de Servicio', property: 'RequireServiceTime', visible: true },
        // { title: 'Tipos de personas', property: 'CodeTypePersons', visible: true },
        // { title: 'Grados Excentos', property: 'ListGradeExempt', visible: true },
        { title: 'Ultima Actualización', property: 'LastUpdate', visible: true },
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar {bean.IDPayrollEntityProperties}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateIten}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Dia de Corte</label>
                            <select className="form-select" value={bean.CutDay ? bean.CutDay.toString().padStart(2, '0') : ""} onChange={(e) => setBean({ ...bean, CutDay: parseInt(e.target.value) })} >
                                <option value="">Seleccione</option>
                                {Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0')).map((day) => (
                                    <option key={day} value={day}>{day}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label>Dia de Notificación</label>
                            <select className="form-select" value={bean.NotifyDay ? bean.NotifyDay.toString().padStart(2, '0') : ""} onChange={(e) => setBean({ ...bean, NotifyDay: parseInt(e.target.value) })} >
                                <option value="">Seleccione</option>
                                {Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0')).map((day) => (
                                    <option key={day} value={day}>{day}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch estado={bean.RequireServiceTime} eventChange={(e) => setBean({ ...bean, RequireServiceTime: e })} label="Requiere tiempo de Servicio" />
                        </div>
                        <div className="col-md-12">
                            <fieldset className="p-2">
                                <ListPropsTypePersons jsonProps={bean.CodeTypePersons} onChange={(e) => { setBean({ ...bean, CodeTypePersons: e }) }} />
                            </fieldset>
                        </div>
                        {bean.CodeTypePersons &&
                            <div className="col-md-12">
                                <fieldset className="p-2">
                                    <GradeExemptEditor onChange={(e) => { setBean({ ...bean, ListGradeExempt: e }) }} jsonSelectedGrades={bean.ListGradeExempt} jsonTypePersons={bean.CodeTypePersons} />
                                </fieldset>
                            </div>
                        }
                        <div className="col-md-12">
                            <fieldset className="p-2">
                                <ListDiscountCodes jsonProps={bean.JSONCodeDiscount} onChange={(e) => { setBean({ ...bean, JSONCodeDiscount: e }) }} />
                            </fieldset>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}